var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"gc-product-tile-wrapper tw-border tw-border-gray-200 tw-overflow-hidden tw-flex tw-w-full"})}
var staticRenderFns = []

export { render, staticRenderFns }